import { observable } from 'mobx';

export type NonOrderItemPriceDetailResponseArgs = {
  id: number;
  price: number;
  purpose?: string;
};

export type NonOrderItemPriceDetailArgs = {
  id: number;
  price: number;
  purpose?: string;
};

export const convertNonOrderItemPriceDetailResponseToArgs = (response: NonOrderItemPriceDetailResponseArgs) => {
  const args: NonOrderItemPriceDetailArgs = {
    id: response.id,
    price: response.price,
    purpose: response.purpose
  };
  return args;
};

export default class NonOrderItemPriceDetail {
  @observable id: number;
  @observable price: number;
  @observable purpose?: string;

  constructor(args: NonOrderItemPriceDetailArgs) {
    this.id = args.id;
    this.price = args.price;
    this.purpose = args.purpose;
  }

  get updateParams() {
    return {
      id: this.id,
      price: this.price,
      purpose: this.purpose
    };
  }
}
